"use strict";
import { useContext } from "react";
import { AuthTokenContext } from "./AuthTokenContext";
export function useAuthTokenContext() {
  const { authToken } = useContext(AuthTokenContext);
  return authToken;
}
